export default __webpack_public_path__ + "static/media/NOKC_BIO_Image-cropped.086f70e7.jpg";